import React from "react";
import { Text } from "..";
import CheckIcon from "src/img/new/green-check.svg";
import {
    AspectBox,
    AspectLabel,
    Wrapper,
    AspectGrid,
    AspectSelectableBox,
    AspectInnerBox,
    CheckmarkWrapper,
} from "../../components/ImageCropModal//ModalCrop.style";

export const AspectRatioSelector = ({
    aspectRatios,
    baseAspect,
    setBaseAspect,
}) => {
    const isAspectSelected = (w, h) =>
        baseAspect.width === w && baseAspect.height === h;

    return (
        <Wrapper>
            <Text family="Manrope" align="left" size="16px" weight="bold">
                Select Aspect Ratio
            </Text>
            <Text size="14px" family="Manrope" align="left">
                Choose from popular ratios like 16:9, 1:1 to format your media for different
                platforms.
            </Text>

            <AspectGrid>
                {aspectRatios.map(aspectData => {
                    const { width, height, label } = aspectData;
                    const maxBoxSize = 38;
                    const boxWidth = width >= height ? maxBoxSize : Math.round((width / height) * maxBoxSize);
                    const boxHeight = width >= height ? Math.round((height / width) * maxBoxSize) : maxBoxSize;

                    return (
                        <AspectBox key={label}>
                            <AspectSelectableBox
                                isSelected={isAspectSelected(width, height)}
                                onClick={() => {
                                    setBaseAspect(aspectData);
                                }}
                            >
                                <AspectInnerBox width={boxWidth} height={boxHeight} />

                                {isAspectSelected(width, height) && (
                                    <CheckmarkWrapper>
                                        <img
                                            src={CheckIcon}
                                            alt="Selected"
                                            style={{
                                                width: "15px",
                                                height: "15px",
                                            }}
                                        />
                                    </CheckmarkWrapper>
                                )}
                            </AspectSelectableBox>
                            <AspectLabel>{label}</AspectLabel>
                        </AspectBox>
                    );
                })}
            </AspectGrid>
        </Wrapper>
    );
};
